<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="liquidacioneselect"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title
              ><v-icon>local_gas_station</v-icon></v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" fab small>
                  <span class="material-icons"> add </span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row class="py-0">
                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-alert type="info">
                          Liquidaciones
                        </v-alert>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-dialog
                          ref="dialog1"
                          v-model="modal1"
                          :return-value.sync="fecha1"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fecha1"
                              :readonly="fecha1 == 1"
                              label="Fecha de Inicio"
                              prepend-icon="event"
                              v-bind="attrs"
                              v-on="on"
                              solo
                              @click="listar()"
                               v-on:change="selectturnofecha()"
                              
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fecha1"
                            scrollable
                            locale="es-es"
                            :readonly="fecha1 == 1"
                              v-on:change="selectturnofecha()"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal1 = false"
                              >Cancelar</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog1.save(fecha1), listar()"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <v-col cols="12" md="12" class="py-0">
                        <v-select
                          v-model="liquidacionturno"
                          :items="liquidacionturnoselect"
                          label="Turno"
                          outlined
                          class="py-0"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="12" class="py-0">
                        <v-select
                          v-model="liquidacionisla"
                          :items="liquidacionislaselect"
                          label="Isla"
                          outlined
                          class="py-0"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="12" class="py-0">
                        <v-select
                          v-model="liquidacionnombre"
                          :items="liquidacionnombreselect"
                          label="Nombre del Despachador"
                          v-on:change="liquidanombre()"
                          outlined
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="12" class="py-0">
                        <v-select
                          v-model="liquidacionbanco"
                          :items="liquidacionbancoselect"
                          label="Nombre del Banco"
                          outlined
                          v-on:change="selectempresanombre()"
                        ></v-select>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-show="valida"
                        class="py-0"
                      >
                        <v-row
                          class="red--text"
                          v-for="v in validamensaje"
                          :key="v"
                          v-text="v"
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <div class="text-center">
                  <v-btn class="mx-2" fab dark large @click="close">
                    <v-icon dark> close </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    large
                    @click="guardar"
                    v-if="guardarvisible == 1"
                  >
                    <v-icon dark> save </v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-dialog>

            <v-dialog v-model="adModal" max-width="700">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1"
                  >¿Deseas Activar El Combustible?</v-card-title
                >
                <v-card-title class="headline" v-if="adAccion == 2"
                  >¿Deseas Suspender El Combustible?</v-card-title
                >
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  el Combustible {{ adNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 1"
                    color="orange darken-4"
                    @click="activar"
                    >Activar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 2"
                    color="orange darken-4"
                    @click="desactivar"
                    >Suspender</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="ver(item)" v-on="on"
                >remove_red_eye</v-icon
              >
            </template>
            <span>Ver Liquidacion</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editar(item)" v-on="on"
                >edit</v-icon
              >
            </template>
            <span>Editar Liquidacion</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="eliminar(item)" v-on="on"
                >delete</v-icon
              >
            </template>
            <span>Eliminar Liquidacion</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>

        <template v-slot:item.gasolinaestatus="{ item }">
          <v-chip
            :color="getColor(item.gasolinaestatus)"
            dark
            v-if="item.gasolinaestatus == 1"
            >ACTIVO</v-chip
          >
          <v-chip
            :color="getColor(item.gasolinaestatus)"
            dark
            v-if="item.gasolinaestatus == 2"
            >SUSPENDIDO</v-chip
          >
        </template>

        <template v-slot:item.liquidacionfecha="{ item }">
          <p>{{ getHumanDate(item.liquidacionfecha) }}</p>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variable categoria
      tipooperaciones: [],
      dialog: false,
      headers: [
        { text: "Accion", value: "action", sortable: false },
        { text: "LiquidacionID", value: "liquidacionid" },
        { text: "Fecha", value: "liquidacionfecha" },
        { text: "Turno", value: "liquidacionturno" },
        { text: "Isla", value: "liquidacionisla" },
        { text: "Nombre", value: "liquidacionnombre" },
      ],


      liquidacionturnoselect: [],

      liquidacionbancoselect: [
        { text: "SELECCIONE BANCO", value: "" },
        { text: "BANORTE", value: "BANORTE" },
        { text: "SANTANDER", value: "SANTANDER" },
        { text: "BBVA", value: "BBVA" },
      ],

      liquidacionnombreselect: [],
      liquidacioneselect: [],
      liquidacionislaselect: [],

      search: "",
      editedIndex: -1,
      //Declaracion de varaibles
      liquidacionid: "",
      liquidacionnombre: "",
      liquidacionturno: "",
      liquidacionisla: "",
      guardarvisible: 1,
      liquidacionnombrecompleto: "",
      fecha1: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),

      modal1: false,

      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],

      // Declara Varaiables para activar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      liquidacionbanco: "",
      banconombre: "",
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nueva Liquidacion"
        : "Actualizar Liquidacion";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() 
  {
    this.listar();
    this.selectusuarios();
    this.selectturnofecha();
    this.selectislas();
  },

  //
  methods: {
    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/liquidaciones/listar", configuracion)
        .then(function(response) {
          me.liquidacioneselect = response.data.liquidacion;
        })
        .catch(function(error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // metodo listar
    selectusuarios() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/usuarios/listar", configuracion)
        .then(function(response) {
          listaArray = response.data.usuarios;
          listaArray.map(function(x) {
            me.liquidacionnombreselect.push({
              text: x.usuarionombre,
              value: x.usuarioid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // metodo listar
    selectturnofecha() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/turnos/listarporfecha/"+me.fecha1, configuracion)
        .then(function(response) {
          listaArray = response.data.turno;
          me.liquidacionturnoselect=[];
          listaArray.map(function(x) {
            me.liquidacionturnoselect.push({
              text: x.turnonumeronombre,
              value: x.turnonumeronumero,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

     // metodo listar
    selectislas() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/islas/listar", configuracion)
        .then(function(response) {
          listaArray = response.data.isla;
          listaArray.map(function(x) {
            me.liquidacionislaselect.push({
              text: x.islanombre,
              value: x.islanumero,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    liquidanombre() {

    },

    // Color
    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103";
      if (socioestatus == 2) return "red";
    },

    selectempresanombre() {
      this.banconombre = event.target.textContent;
    },

    // Actualiza la categotia
    ver(item) {
      this.liquidacionid = item.liquidacionid;
      this.liquidacionnombre = item.usuarioid;
      this.liquidacionturno = item.liquidacionturno;
      this.liquidacionisla = item.liquidacionisla;
      this.fecha1 = item.liquidacionfecha;
      this.liquidacionbanco = item.liquidacionbanco;
      this.banconombre=item.liquidacionbanco;
      this.editedIndex = 1;
      this.guardarvisible = 0;
      this.dialog = true;
    },

    editar(item) {
      
      this.liquidacionid = item.liquidacionid;
      this.liquidacionnombre = item.usuarioid;
      this.liquidacionturno = item.liquidacionturno;
      this.liquidacionisla = item.liquidacionisla;
      this.liquidacionbanco = item.liquidacionbanco;
      this.fecha1 = item.liquidacionfecha;
      this.banconombre=item.liquidacionbanco;
      this.editedIndex = 1;
      this.guardarvisible = 1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.guardarvisible = 1;
      this.limpiar();
    },

    limpiar() {
      this.liquidacionid = "";
      this.liquidacionnombre = "";
      this.liquidacionturno = "";
      this.liquidacionisla = "";
      this.banconombre="",
      this.liquidacionbanco="";

      this.fecha1 = moment(
        this.$store.state.usuario.fecha,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
    },

    eliminar(liquidacion) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text: "El Usuario: " + liquidacion.liquidacionnombre,

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              "api/liquidaciones/eliminar/" + liquidacion.liquidacionid,
              {},
              configuracion
            )
            .then(function(response) {
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function(error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    guardar() {
      
      if (this.liquidacionturno == "") {
        this.$swal("No se a Capturado El Turno");
        return;
      }

      if (this.liquidacionisla == "") {
        this.$swal("No se a Capturado La Isla");
        return;
      }

      if (this.liquidacionnombre == "") {
        this.$swal("No se a Capturado el Despachador");
        return;
      }

      if (this.liquidacionbanco == "") {
        this.$swal("No se a Capturado El Banco");
        return;
      }

      this.guardarvisible = 0;


      var qs = require("qs");
      var data = qs.stringify({
        json:
          '{"liquidacionid":"' +
          this.liquidacionid +
          '","liquidacionturno":"' +
          this.liquidacionturno +
          '","liquidacionisla":"' +
          this.liquidacionisla +
          '","liquidacionnombre":"' +
          this.liquidacionnombre +
          '","liquidacionfecha":"' +
          this.fecha1 +
          '","liquidacionbanco":"' +
          this.banconombre +
          '","usuarioid":"' +
          this.liquidacionnombre +
          '"}',
      });

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //Editar
        let me = this;
        axios
          .put(
            "api/liquidaciones/actualizar/" + me.liquidacionid,
            data,
            configuracion
          )
          .then(function(response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Carga de Gasolina Actualizado con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      } else {
        //Guardar
        let me = this;
        axios
          .post("api/liquidaciones/crear", {
            liquidacionid:me.liquidacionid,
            liquidacionturno:me.liquidacionturno,
            liquidacionisla:me.liquidacionisla,
            liquidacionnombre:me.liquidacionnombre,
            liquidacionfecha:me.fecha1,
            liquidacionbanco:me.liquidacionbanco,
            usuarioid:me.$store.state.usuario.usuarioid
          }, configuracion)
          .then(function(response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Registrio Generado Con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.vehiculoid) {
        this.validamensaje.push("Vehiculo Vacio");
      }
      if (!this.gasolinacarga) {
        this.validamensaje.push("Importe de Carga Vacio");
      }
      if (!this.gasolinatipo) {
        this.validamensaje.push("Tipo de Gasolina Vacio");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.gasolinaid;
      this.gasolinaid = item.gasolinaid;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"gasolinaestatus":"1"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/gasolinas/activargasolinas/" + this.gasolinaid,
          data,
          configuracion
        )
        .then(function(response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    desactivar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"gasolinaestatus":"2"}',
      });
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/gasolinas/activargasolinas/" + this.gasolinaid,
          data,
          configuracion
        )
        .then(function(response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
  },
};
</script>
